export default {
    minimumFlexTargetPremium: (eligiblePremium, percentageAllowed) => {
        const parsedPercentage = (100 + percentageAllowed) * 0.01;
        return eligiblePremium * parsedPercentage;
    },
};
